export const superadmin = api => ({
  getActivity(id, data, success, fail) {
    api.authenticatedRequest('POST', `/superadmin/${id}/activity`, data, success, fail);
  },
  getSuperadmins(success, fail) {
    api.authenticatedRequest('GET', '/superadmin/users', null, success, fail);
  },
  evaluateScript(data, success, fail) {
    api.authenticatedRequest('POST', '/superadmin/scripts/execute', data, success, fail);
  },
  getScript(term, success, fail) {
    api.authenticatedRequest('GET', `/superadmin/scripts?query=${term || ''}`, null, success, fail);
  },
  createScript(data, success, fail) {
    api.authenticatedRequest('POST', '/superadmin/scripts', data, success, fail);
  },
  editScript(id, data, success, fail) {
    api.authenticatedRequest('PUT', `/superadmin/scripts/${id}`, data, success, fail);
  },
  deleteScript(id, success, fail) {
    api.authenticatedRequest('DELETE', `/superadmin/scripts/${id}`, null, success, fail);
  },
  sendEmail(data, success, fail) {
    api.authenticatedRequest('POST', '/superadmin/email', data, success, fail);
  },
  getApiQuota(success, fail) {
    api.authenticatedRequest('GET', '/superadmin/api', null, success, fail);
  },
  forceCrash(data, success, fail) {
    api.authenticatedRequest('POST', '/superadmin/developers/crash', data, success, fail);
  },
  getGlobalSettings(success, fail) {
    api.authenticatedRequest('GET', '/superadmin/settings', null, success, fail);
  },
  updateGlobalCreditsafeSettings(data, success, fail) {
    api.authenticatedRequest('POST', '/superadmin/settings/creditsafe', data, success, fail);
  },
  getPowerbiConnection(success, fail) {
    api.authenticatedRequest('GET', '/superadmin/powerbi', null, success, fail);
  },
  deletePowerbiConnection(success, fail) {
    api.authenticatedRequest('DELETE', '/superadmin/powerbi', null, success, fail);
  },
  getPowerbiWorkspaces(success, fail) {
    api.authenticatedRequest('GET', '/superadmin/powerbi/workspaces', null, success, fail);
  },
  createPowerbiDataset(datasetType, workspaceId, workspaceName, success, fail) {
    api.authenticatedRequest('POST', '/superadmin/powerbi/datasets', { datasetType, workspaceId, workspaceName }, success, fail);
  },
  syncPowerbiDataset(datasetId, success, fail) {
    api.authenticatedRequest('POST', `/superadmin/powerbi/datasets/${datasetId}`, null, success, fail);
  },
  deletePowerbiDataset(datasetId, success, fail) {
    api.authenticatedRequest('DELETE', `/superadmin/powerbi/datasets/${datasetId}`, null, success, fail);
  },
  searchRoles(query, success, fail) {
    api.authenticatedRequest('GET', `/superadmin/roles/search?query=${query || ''}`, null, success, fail);
  },
  allChallenges(params, success, fail) {
    const queryParams = new URLSearchParams(params).toString();
    api.authenticatedRequest('GET', `/superadmin/challenges?${queryParams}`, null, success, fail);
  },
  allIdeas(params, success, fail) {
    const queryParams = new URLSearchParams(params).toString();
    api.authenticatedRequest('GET', `/superadmin/ideas?${queryParams}`, null, success, fail);
  }
});
